import { OTP_STATUS } from '@/constants/otp';
/* eslint-disable default-param-last */
export const types = {
  SEND_OTP: 'SMS/SEND_OTP',
  SEND_OTP_SUCCESS: 'SMS/SEND_OTP_SUCCESS',
  SEND_OTP_ERROR: 'SMS/SEND_OTP_ERROR',
  VALIDATE_OTP: 'SMS/VALIDATE_OTP',
  VALIDATE_OTP_SUCCESS: 'SMS/VALIDATE_OTP_SUCCESS',
  VALIDATE_OTP_ERROR: 'SMS/VALIDATE_OTP_ERROR',
  VALIDATE_ALL_OTPS: 'SMS/VALIDATE_ALL_OTPS',
  VALIDATE_ALL_OTPS_ERROR: 'SMS/VALIDATE_ALL_OTPS_ERROR',
  SET_REQUIRED_OTPS: 'SMS/SET_REQUIRED_OTPS',
};

export const actions = {
  sendOtp: (data) => ({
    type: types.SEND_OTP,
    payload: { data },
  }),
  sendOtpSuccess: (data) => ({
    type: types.SEND_OTP_SUCCESS,
    payload: { data },
  }),
  sendOtpError: (data) => ({
    type: types.SEND_OTP_ERROR,
    payload: { data },
  }),
  validateOtp: (data) => ({
    type: types.VALIDATE_OTP,
    payload: { data },
  }),
  validateOtpSuccess: (data) => ({
    type: types.VALIDATE_OTP_SUCCESS,
    payload: { data },
  }),
  validateOtpError: (data) => ({
    type: types.VALIDATE_OTP_ERROR,
    payload: { data },
  }),
  validateAllOTPs: (data) => ({
    type: types.VALIDATE_ALL_OTPS,
    payload: { data },
  }),
  validateAllOTPsError: (data) => ({
    type: types.VALIDATE_ALL_OTPS_ERROR,
    payload: { data },
  }),
  setRequiredOTPs: (data) => ({
    type: types.SET_REQUIRED_OTPS,
    payload: { data },
  }),
};

const initialState = {
  requiredOTPs: null,
  validatingAllOTPs: false,
};

function reducer(state = { ...initialState }, action) {
  switch (action.type) {
    case types.SEND_OTP: {
      const { data } = { ...action.payload };
      const { phoneNumber } = { ...data };
      const requiredOTPs = state.requiredOTPs.map((item) => {
        if (item.phoneNumber === phoneNumber) {
          return {
            ...item,
            sendingOtp: true,
            otpValidateError: null,
            validatingOtp: false,
            status: null,
          };
        }
        return item;
      });
      return {
        ...state,
        requiredOTPs,
        validatingAllOTPs: false,
      };
    }
    case types.SEND_OTP_SUCCESS: {
      const { data } = { ...action.payload };
      const { phoneNumber } = { ...data };
      const requiredOTPs = state.requiredOTPs.map((item) => {
        if (item.phoneNumber === phoneNumber) {
          return {
            ...item,
            sendingOtp: false,
            otpSent: true,
          };
        }
        return item;
      });
      return {
        ...state,
        requiredOTPs,
      };
    }
    case types.VALIDATE_OTP: {
      const { data } = { ...action.payload };
      const { phoneNumber } = { ...data };
      const requiredOTPs = state.requiredOTPs.map((item) => {
        if (item.phoneNumber === phoneNumber) {
          return {
            ...item,
            otpValidated: false,
            otpValidateError: null,
            validatingOtp: true,
          };
        }
        return item;
      });
      return {
        ...state,
        requiredOTPs,
      };
    }
    case types.VALIDATE_OTP_SUCCESS: {
      const { data } = { ...action.payload };
      const { phoneNumber } = { ...data };
      const requiredOTPs = state.requiredOTPs.map((item) => {
        if (item.phoneNumber === phoneNumber) {
          return {
            ...item,
            otpValidated: true,
            status: OTP_STATUS.VALID,
          };
        }
        return item;
      });
      return {
        ...state,
        requiredOTPs,
      };
    }
    case types.VALIDATE_OTP_ERROR: {
      const { data } = { ...action.payload };
      const { phoneNumber, error } = { ...data };
      const requiredOTPs = state.requiredOTPs.map((item) => {
        if (item.phoneNumber === phoneNumber) {
          return {
            ...item,
            validatingOtp: false,
            otpValidated: false,
            otpValidateError: error,
          };
        }
        return item;
      });
      return {
        ...state,
        requiredOTPs,
      };
    }
    case types.VALIDATE_ALL_OTPS: {
      return {
        ...state,
        validatingAllOTPs: true,
      };
    }
    case types.VALIDATE_ALL_OTPS_ERROR: {
      return {
        ...state,
        validatingAllOTPs: false,
      };
    }
    case types.SET_REQUIRED_OTPS: {
      const { data } = { ...action.payload };
      return {
        ...state,
        requiredOTPs: data,
      };
    }
    default:
      return state;
  }
}

export default reducer;
